import { render, staticRenderFns } from "./Meals.vue?vue&type=template&id=13a4c344&scoped=true&"
import script from "./Meals.vue?vue&type=script&lang=js&"
export * from "./Meals.vue?vue&type=script&lang=js&"
import style0 from "./Meals.scss?vue&type=style&index=0&id=13a4c344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4c344",
  null
  
)

export default component.exports